module.exports = "/assets/deb9fe0b9a8199e2ac66c5958264f122.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VA.png
// module id = 3038
// module chunks = 0